module.exports = {"469028100":"椰林镇","469028101":"光坡镇","469028102":"三才镇","469028103":"英州镇","469028104":"隆广镇","469028105":"文罗镇","469028106":"本号镇","469028107":"新村镇","469028108":"黎安镇","469028200":"提蒙乡","469028201":"群英乡","469028500":"国营吊罗山林业公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469028.json
// module id = 2338
// module chunks = 0